define('taoQtiItem/qtiItem/core/choices/Gap',['taoQtiItem/qtiItem/core/choices/Choice'], function(QtiChoice){
    var QtiGap = QtiChoice.extend({
        qtiClass : 'gap'
    });
    return QtiGap;
});



